module.exports = __webpack_public_path__ + "img/b328c9f.png";